import { Box, Grid, Typography } from "@mui/material";
import ButtonCustom from "src/shared/components/buttons/ButtonCustom";
import EmailField from "../components/EmailField";
import RutField from "../components/RutField";
import useSavePatient from "../hooks/useSavePatient";

const Index = () => {

    const { handleResendCodeConfirmation } = useSavePatient()

    return (
        <div>
            <Typography variant="subtitle1" color="primary">
                Indique su Rut y correo electrónico
            </Typography>

            <Grid container spacing={2} mt={2}>
                <Grid item md={12} xs={12}>
                    <RutField />
                </Grid>
                <Grid item md={12} xs={12}>
                    <EmailField />
                </Grid>
            </Grid>

            <Grid container display={"flex"} justifyContent={"center"} p={2} mt={1}>
                <Box>
                    <ButtonCustom
                        color="secondary"
                        //loading={loading}
                        text="ENVIAR CÓDIGO"
                        //icon={<NavigateNextIcon />}
                        onClick={handleResendCodeConfirmation}
                    />
                </Box>

            </Grid>
        </div>
    )
}

export default Index;